import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=3e3ee56a&scoped=true&"
import script from "./reward.vue?vue&type=script&lang=js&"
export * from "./reward.vue?vue&type=script&lang=js&"
import style0 from "./reward.vue?vue&type=style&index=0&id=3e3ee56a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3ee56a",
  null
  
)

export default component.exports